import { Box } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import Sidebar from "../components/sidebar";
import Topbar, { Breadcrumb } from "../components/topbar";
import { useMatches } from "react-router-dom";
import { routes } from "../config/navigation";
import { LayoutContext } from "../contexts/LayoutContext";
import { useAuth } from "../contexts/UserContext";
import { AccountProvider } from "../contexts/AccountContext";
import { OrganizationProvider } from "../contexts/OrganizationContext";
import GlobalNotification from "../components/notification/GlobalNotification";
import OnboardingReminderBanner from "../components/notification/OnboardingReminderBanner";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openSignOut, setOpenSignOut] = useState(false);

  const [profile, setProfile] = useState<string | undefined>();
  const [breadcrumbTail, setBreadcrumbTail] = useState<string | undefined>();

  let headlineImg: string | undefined = undefined;
  const matches = useMatches();
  const breadcrumbs: Breadcrumb[] = [];
  matches.forEach((match) => {
    const { pathname } = match;
    const route = routes.find((item) => item.path === pathname);
    // A nested index route matches the same pathname as its parent; list it once.
    if (route && breadcrumbs[breadcrumbs.length - 1]?.link !== pathname) {
      const breadcrumb = route.title;
      const img = route.image;
      if (img) {
        headlineImg = img;
      }
      breadcrumbs.push({
        text: breadcrumb,
        link: pathname,
      });
    }
  });
  // A page whose title is data (a borrower's name) adds it as the last crumb.
  const lastPath = matches[matches.length - 1]?.pathname;
  if (breadcrumbTail && lastPath && breadcrumbs[breadcrumbs.length - 1]?.link !== lastPath) {
    breadcrumbs.push({ text: breadcrumbTail, link: lastPath, translated: true });
  }

  const { user } = useAuth();

  useEffect(() => {
    setProfile(user?.userProfile);
  }, [user?.userProfile]);

  const context = {
    openSidebar,
    setOpenSidebar,
    openSignOut,
    setOpenSignOut,
    profile,
    setProfile,
    breadcrumbTail,
    setBreadcrumbTail,
  };

  return (
    <LayoutContext.Provider value={context}>
      <AccountProvider>
        <OrganizationProvider>
          <Box
            display={"flex"}
            flexDirection={"column"}
            color={"var(--white)"}
            height="100vh"
            sx={{
              backgroundColor: "#F2F2F2",
              overflowY: "hidden",
            }}
            minHeight={0}
          >
            <Sidebar />

            <Box
              flexGrow={1}
              display={"flex"}
              flexDirection={"column"}
              marginLeft={{ xs: 0, md: "90px" }}
              sx={{ overflowY: "hidden" }}
              minHeight={0}
            >
              <Topbar img={headlineImg} breadcrumbs={breadcrumbs} />

              <OnboardingReminderBanner />

              <Box
                flexGrow={1}
                width={"100%"}
                height={"100%"}
                sx={{ overflowY: "auto", scrollbarGutter: "stable" }}
                minHeight={0}
              >
                {children}
              </Box>
            </Box>
          </Box>

          {/* ✅ วาง Notification ไว้ตรงนี้ มันจะไม่ไปโผล่ในหน้า /select-organization แล้ว */}
          <GlobalNotification />
        </OrganizationProvider>
      </AccountProvider>
    </LayoutContext.Provider>
  );
};

export default Layout;
